<!--
  [2026-08-24] v5 창구 전용 '계약서 작성 완료' 모달.

  v1 의 CreateContractSuccessModal.vue 를 복사했다. 목록 이동 경로는 버전 없는 고정 주소
  (CONTRACT_LIST_PATH = /contract/list)를 쓴다 — 창구가 바뀌어도 이 파일은 그대로다.
  나머지는 원본과 동일하다.

  v1 원본에 prop 을 추가해 공용화하지 않은 이유: 그 파일은 v1 화면 23 개가 공유하고,
  `npm run check:contracts-v3-preserve` 가 v1 파일 무변경을 강제한다(실제로 이 가드가 1 차 시도를 막았다).
  v5 화면들이 v1 을 미러링해 복제된 구조를 따르는 것이 이 리포의 관행이기도 하다.

  원본이 바뀌면 이 파일도 따라가야 한다(경로 2 줄 제외).
-->
<template>
  <a-modal v-model:open="computedShowModal"
           width="380px"
           :closable="false"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
  >
    <div class="modal-content-body">
      <div class="container">
        <div class="image">
          <img v-if="isDentiumManufacturer && SuccessType.KakaoAndTwoSign"
               src="@/assets/img/contract/create_contract_secure_link_v2.png"
               alt="Contract Success">
          <img v-if="isDentiumManufacturer && SuccessType.SecureLinkAndTwoSign"
               src="@/assets/img/contract/create_contract_secure_link_v2.png"
               alt="Contract Success">
          <img v-if="isDentiumManufacturer && SuccessType.KakaoAndOneSign"
               src="@/assets/img/contract/create_contract_secure_link_v2.png"
               alt="Contract Success">
          <img v-if="isDentiumManufacturer && SuccessType.SecureLinkAndOneSign"
               src="@/assets/img/contract/create_contract_secure_link_v2.png"
               alt="Contract Success">
          <img v-if="isPlasmappManufacturer"
               src="@/assets/img/contract/create_contract_secure_link_v2_plasmapp.png"
               alt="Contract Success">
        </div>
        <div class="text">
          <h5>계약서 작성 완료!</h5>
          <a-typography-text type="secondary"
                             style="color: #6c757d; font-size: 16px; line-height: 24px;">카카오 알림톡을 확인 후, 계약 상대방 측의 서명을
            받아주세요.
          </a-typography-text>
        </div>
        <div v-if="signMethod === ModuSignMethod.KAKAO"
             class="button">
          <button @click="(e) => $router.push(contractListPath)">목록으로 이동하기</button>
        </div>
        <div v-else-if="signMethod === ModuSignMethod.SECURE_LINK"
             class="button">
          <button @click="uiHandler.directSign" style="background-color: #ffe414">지금 바로 서명하기</button>
          <br>
          <button @click="(e) => $router.push(contractListPath)" style="color: #6c757d">나중에 하기</button>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { getAccessToken } from '@/utils/tokenStore';
import {EmitEvents} from "@/views/ContractManagement/contracts/dentium/EmitEvents";
import contractsApiInstance from "@/contractsApi";
import {ModuSignMethod} from "@/views/ContractManagement/enums";
import {jwtDecoder, oneBtnDialog} from "@/utils/utils";

import {CONTRACT_LIST_PATH} from '@/utils/contractConsole';
export default {
  components: {},
  emits: Object.keys({...EmitEvents.Common}),
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    signMethod: {
      type: String,
      required: false,
      default: ModuSignMethod.KAKAO
    },
    secureLinkParam: {
      type: Object,
      required: true,
      validator(value) {
        return value && typeof value.contractId === 'string' && typeof value.participantId === 'string';
      }
    },
    contractType: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    computedShowModal() {
      return this.showModal;
    },
    ModuSignMethod() {
      return ModuSignMethod
    },
    isDentiumManufacturer() {
      const companyId = jwtDecoder(getAccessToken());
      return process.env.VUE_APP_DENTIUM_ID === companyId
    },
    isPlasmappManufacturer() {
      const companyId = jwtDecoder(getAccessToken());
      return process.env.VUE_APP_PLASMAPP_ID === companyId
    },
    SuccessType() {
      return {
        KakaoAndTwoSign: this.signMethod === ModuSignMethod.KAKAO && this.contractType !== '덴티움-물품매매계약서',
        KakaoAndOneSign: this.signMethod === ModuSignMethod.KAKAO && this.contractType === '덴티움-물품매매계약서',
        SecureLinkAndTwoSign: this.signMethod === ModuSignMethod.SECURE_LINK && this.contractType !== '덴티움-물품매매계약서',
        SecureLinkAndOneSign: this.signMethod === ModuSignMethod.SECURE_LINK && this.contractType === '덴티움-물품매매계약서'
      }
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractListPath: CONTRACT_LIST_PATH,
      url: '',
    }
  },
  methods: {
    ui() {
      return {
        emitClient: () => {
          this.$emit(EmitEvents.SummaryModal.SummaryConfirm, true);
        },
        directSign: async () => {
          await this.apiHandler.sendSecureSignLink(this.secureLinkParam, async (response) => {
            if (response) {
              window.open(response?.data?.embeddedUrl)
            }
          }, (error) => {
            oneBtnDialog('fail', JSON.stringify(error))
          });
        },
        awaitForUrl: async (url) => {
          if (!url) return;
          this.url = url;
        },
      }
    },
    api() {
      return {
        sendSecureSignLink: async (params, success, fail) => {
          this.$store.commit('setIsLoading', true);
          return contractsApiInstance.post(`/contracts/secure-sign-link`, params)
              .then((response) => {
                success(response);
              }, (error) => {
                console.log(error);
                fail(error);
              }).finally(() => this.$store.commit('setIsLoading', false));
        },
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/search-client-modal.scss';
</style>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px;

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 40px;
  }

  .image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 40px 0 40px;
    margin-bottom: 40px;
  }

  .button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
  }

  .button button {
    width: 160px;
  }
}
</style>
